var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneSettings3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83651 4.59851C10.4103 4.02473 11.1885 3.70239 11.9999 3.70239C12.8114 3.70239 13.5896 4.02473 14.1633 4.59851C14.7371 5.17228 15.0594 5.95048 15.0594 6.76192C15.0594 7.17613 15.3952 7.51192 15.8094 7.51192C16.2237 7.51192 16.5594 7.17613 16.5594 6.76192C16.5594 5.55266 16.0791 4.39292 15.224 3.53785C14.3689 2.68277 13.2092 2.20239 11.9999 2.20239C10.7907 2.20239 9.63093 2.68277 8.77585 3.53785C7.92077 4.39292 7.44039 5.55266 7.44039 6.76192V10.7738H7.23801C5.77183 10.7738 4.58325 11.9624 4.58325 13.4286V19.1429C4.58325 20.6091 5.77183 21.7976 7.23801 21.7976H16.7618C18.228 21.7976 19.4166 20.6091 19.4166 19.1429V13.4286C19.4166 11.9624 18.228 10.7738 16.7618 10.7738H8.94039V6.76192C8.94039 5.95048 9.26274 5.17228 9.83651 4.59851ZM8.19039 12.2738H7.23801C6.60026 12.2738 6.08325 12.7908 6.08325 13.4286V19.1429C6.08325 19.7806 6.60026 20.2976 7.23801 20.2976H16.7618C17.3996 20.2976 17.9166 19.7806 17.9166 19.1429V13.4286C17.9166 12.7908 17.3996 12.2738 16.7618 12.2738H8.19039Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSettings3);
export default __webpack_public_path__ + "static/media/phone-settings3.8f7c33aec15af989d2b3a9bbe1d31da4.svg";
export { ForwardRef as ReactComponent };